/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createExportLambda = /* GraphQL */ `
  mutation CreateExportLambda($input: CreateExportInput) {
    createExportLambda(input: $input) {
      id
      name
      dateStart
      dateEnd
      status
      count
      audience {
        items {
          id
          audienceID
          exportID
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      destiny
      createdAt
      updatedAt
      exportUserId
    }
  }
`;
export const deleteExportLambda = /* GraphQL */ `
  mutation DeleteExportLambda($input: ID!) {
    deleteExportLambda(input: $input)
  }
`;
export const editExportLambda = /* GraphQL */ `
  mutation EditExportLambda($input: CreateExportInput) {
    editExportLambda(input: $input)
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      name
      job
      rol
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      audiences {
        items {
          id
          name
          isPublic
          createdAt
          updatedAt
          userAudiencesId
          audienceUserId
        }
        nextToken
      }
      createdAt
      updatedAt
      userCompanyId
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      name
      job
      rol
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      audiences {
        items {
          id
          name
          isPublic
          createdAt
          updatedAt
          userAudiencesId
          audienceUserId
        }
        nextToken
      }
      createdAt
      updatedAt
      userCompanyId
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      name
      job
      rol
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      audiences {
        items {
          id
          name
          isPublic
          createdAt
          updatedAt
          userAudiencesId
          audienceUserId
        }
        nextToken
      }
      createdAt
      updatedAt
      userCompanyId
    }
  }
`;
export const createCompany = /* GraphQL */ `
  mutation CreateCompany(
    $input: CreateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    createCompany(input: $input, condition: $condition) {
      id
      name
      address
      country
      region
      postalZip
      employees
      createdAt
      updatedAt
    }
  }
`;
export const updateCompany = /* GraphQL */ `
  mutation UpdateCompany(
    $input: UpdateCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    updateCompany(input: $input, condition: $condition) {
      id
      name
      address
      country
      region
      postalZip
      employees
      createdAt
      updatedAt
    }
  }
`;
export const deleteCompany = /* GraphQL */ `
  mutation DeleteCompany(
    $input: DeleteCompanyInput!
    $condition: ModelCompanyConditionInput
  ) {
    deleteCompany(input: $input, condition: $condition) {
      id
      name
      address
      country
      region
      postalZip
      employees
      createdAt
      updatedAt
    }
  }
`;
export const createFilterValue = /* GraphQL */ `
  mutation CreateFilterValue(
    $input: CreateFilterValueInput!
    $condition: ModelFilterValueConditionInput
  ) {
    createFilterValue(input: $input, condition: $condition) {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;
export const updateFilterValue = /* GraphQL */ `
  mutation UpdateFilterValue(
    $input: UpdateFilterValueInput!
    $condition: ModelFilterValueConditionInput
  ) {
    updateFilterValue(input: $input, condition: $condition) {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;
export const deleteFilterValue = /* GraphQL */ `
  mutation DeleteFilterValue(
    $input: DeleteFilterValueInput!
    $condition: ModelFilterValueConditionInput
  ) {
    deleteFilterValue(input: $input, condition: $condition) {
      id
      key
      value
      description
      createdAt
      updatedAt
    }
  }
`;
export const createAudience = /* GraphQL */ `
  mutation CreateAudience(
    $input: CreateAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    createAudience(input: $input, condition: $condition) {
      id
      isPublic
      is_deleted
      name
      updatedAt
      userAudiencesId
      createdAt
      count
      audienceUserId
      user {
        userCompanyId
        updatedAt
        name
        rol
        job
        is_deleted
        id
        createdAt
        author
        audiences {
          nextToken
        }
        company {
          address
          createdAt
          country
          employees
          id
          is_deleted
          postalZip
          name
          region
          updatedAt
        }
      }
      exports {
        nextToken
        items {
          audienceID
          createdAt
          exportID
          id
          updatedAt
        }
      }
      filters {
        value_filter
        type_filter
        type_behaviour
        key
        description_filter
      }
    }
  }
`;
export const updateAudience = /* GraphQL */ `
  mutation UpdateAudience(
    $input: UpdateAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    updateAudience(input: $input, condition: $condition) {
      id
      name
      filters {
        id
        type_filter
        value_filter
        description_filter
      }
      isPublic
      is_deleted
      updatedAt
      userAudiencesId
      audienceUserId
      createdAt
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          createdAt
          updatedAt
          region
          postalZip
          is_deleted
          employees
        }
        audiences {
          nextToken
        }
      }
      exports {
        items {
          id
          audienceID
          createdAt
          updatedAt
          exportID
        }
        nextToken
      }
    }
  }
`;
export const deleteAudience = /* GraphQL */ `
  mutation DeleteAudience(
    $input: DeleteAudienceInput!
    $condition: ModelAudienceConditionInput
  ) {
    deleteAudience(input: $input, condition: $condition) {
      audienceUserId
      count
      createdAt
      id
      isPublic
      is_deleted
      name
      updatedAt
      userAudiencesId
      filters {
        description_filter
        key
        type_filter
        value_filter
      }
      user {
        id
        createdAt
        is_deleted
        job
        name
        rol
        updatedAt
        userCompanyId
        author
        audiences {
          nextToken
        }
        company {
          address
          country
          createdAt
          employees
          id
          is_deleted
          name
          postalZip
          region
          updatedAt
        }
      }
      exports {
        nextToken
        items {
          updatedAt
          id
          exportID
          createdAt
          audienceID
        }
      }
    }
  }
`;
export const createExport = /* GraphQL */ `
  mutation CreateExport(
    $input: CreateExportInput!
    $condition: ModelExportConditionInput
  ) {
    createExport(input: $input, condition: $condition) {
      id
      name
      dateStart
      dateEnd
      id_status
      updatedAt
      destiny
      exportUserId
      createdAt
      count
      is_deleted
      audience {
        items {
          id
          audienceID
          createdAt
          updatedAt
          exportID
        }
        nextToken
      }
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          createdAt
          updatedAt
          region
          postalZip
        }
        createdAt
        updatedAt
        userCompanyId
        audiences {
          nextToken
        }
      }
    }
  }
`;
export const updateExport = /* GraphQL */ `
  mutation UpdateExport(
    $input: UpdateExportInput!
    $condition: ModelExportConditionInput
  ) {
    updateExport(input: $input, condition: $condition) {
      id
      name
      dateStart
      dateEnd
      status
      count
      audience {
        items {
          id
          audienceID
          exportID
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      destiny
      createdAt
      updatedAt
      exportUserId
    }
  }
`;
export const deleteExport = /* GraphQL */ `
  mutation DeleteExport(
    $input: DeleteExportInput!
    $condition: ModelExportConditionInput
  ) {
    deleteExport(input: $input, condition: $condition) {
      id
      name
      dateStart
      dateEnd
      status
      count
      audience {
        items {
          id
          audienceID
          exportID
          createdAt
          updatedAt
        }
        nextToken
      }
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      destiny
      createdAt
      updatedAt
      exportUserId
    }
  }
`;
export const createCLM = /* GraphQL */ `
  mutation CreateCLM(
    $input: CreateCLMInput!
    $condition: ModelCLMConditionInput
  ) {
    createCLM(input: $input, condition: $condition) {
      id
      name
      status
      date
      createdAt
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      adiditionalAttributes
      matchedSubscribers
      recordCount
      pathFile
      updatedAt
      cLMUserId
      cLMCompanyId
    }
  }
`;
export const updateCLM = /* GraphQL */ `
  mutation UpdateCLM(
    $input: UpdateCLMInput!
    $condition: ModelCLMConditionInput
  ) {
    updateCLM(input: $input, condition: $condition) {
      id
      name
      status
      date
      createdAt
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      adiditionalAttributes
      matchedSubscribers
      recordCount
      pathFile
      updatedAt
      cLMUserId
      cLMCompanyId
    }
  }
`;
export const deleteCLM = /* GraphQL */ `
  mutation DeleteCLM(
    $input: DeleteCLMInput!
    $condition: ModelCLMConditionInput
  ) {
    deleteCLM(input: $input, condition: $condition) {
      id
      name
      status
      date
      createdAt
      user {
        id
        name
        job
        rol
        company {
          id
          name
          address
          country
          region
          postalZip
          employees
          createdAt
          updatedAt
        }
        audiences {
          nextToken
        }
        createdAt
        updatedAt
        userCompanyId
      }
      company {
        id
        name
        address
        country
        region
        postalZip
        employees
        createdAt
        updatedAt
      }
      adiditionalAttributes
      matchedSubscribers
      recordCount
      pathFile
      updatedAt
      cLMUserId
      cLMCompanyId
    }
  }
`;
export const createAudienceExport = /* GraphQL */ `
  mutation CreateAudienceExport(
    $input: CreateAudienceExportInput!
    $condition: ModelAudienceExportConditionInput
  ) {
    createAudienceExport(input: $input, condition: $condition) {
      id
      audienceID
      exportID
      audience {
        id
        name
        filters {
          description_filter
          key
          type_filter
          value_filter
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        isPublic
        exports {
          nextToken
        }
        createdAt
        updatedAt
        userAudiencesId
        audienceUserId
      }
      export {
        id
        name
        dateStart
        dateEnd
        status
        count
        audience {
          nextToken
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        destiny
        createdAt
        updatedAt
        exportUserId
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateAudienceExport = /* GraphQL */ `
  mutation UpdateAudienceExport(
    $input: UpdateAudienceExportInput!
    $condition: ModelAudienceExportConditionInput
  ) {
    updateAudienceExport(input: $input, condition: $condition) {
      id
      audienceID
      exportID
      audience {
        id
        name
        filters {
          id
          key
          value
          description
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        isPublic
        exports {
          nextToken
        }
        createdAt
        updatedAt
        userAudiencesId
        audienceUserId
      }
      export {
        id
        name
        dateStart
        dateEnd
        status
        count
        audience {
          nextToken
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        destiny
        createdAt
        updatedAt
        exportUserId
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteAudienceExport = /* GraphQL */ `
  mutation DeleteAudienceExport(
    $input: DeleteAudienceExportInput!
    $condition: ModelAudienceExportConditionInput
  ) {
    deleteAudienceExport(input: $input, condition: $condition) {
      id
      audienceID
      exportID
      audience {
        id
        name
        filters {
          id
          key
          value
          description
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        isPublic
        exports {
          nextToken
        }
        createdAt
        updatedAt
        userAudiencesId
        audienceUserId
      }
      export {
        id
        name
        dateStart
        dateEnd
        status
        count
        audience {
          nextToken
        }
        user {
          id
          name
          job
          rol
          createdAt
          updatedAt
          userCompanyId
        }
        destiny
        createdAt
        updatedAt
        exportUserId
      }
      createdAt
      updatedAt
    }
  }
`;
